<div class="grid {{layout}}" >
	<ng-container *ngFor="let listing of listings">
		<ng-container *ngIf="(listingDetailMap?.[listing.id] || !listingShowChildrenMap?.[listing.id]); else breakIntoChildren">
			<ng-container
				*ngTemplateOutlet="listingCard;
				context: { listing: listing, details: listingDetailMap?.[listing.id] }"
			></ng-container>
		</ng-container>

		<ng-template #breakIntoChildren>
			<ng-container *ngFor="let child of listing.children">
				<ng-container
					*ngTemplateOutlet="listingCard;
					context: { listing: child, parent: listing, details: listingChildDetailMap?.[child.id] }">
				</ng-container>
			</ng-container>
		</ng-template>
	</ng-container>
</div>

<ng-template #listingCard let-listing="listing" let-parent="parent" let-details="details">
	<div
		class="listing-container"
		[ngClass]="{'showing-details': showDetails}"
		*localVar="(showSizeDetails && details) as showDetails"
	>
		<app-creative-unit-package-listing-card
			class="card {{thumbnailStyle}}"
			[listing]="listing"
			[parentListing]="parent"
			[highlightQuery]="searchQuery"
			(click)="selectedListing.emit(listing)"
		></app-creative-unit-package-listing-card>

		<div class="details" *ngIf="showDetails">
			<app-cart-list
				class="pb-1 block full-width"
				mode="list"
				[showHeader]="false"
				[showReview]="false"
				[showSizeCount]="false"
				[showExpandableDetails]="false"
				[showGroupActions]="false"
				[useItemTranslations]="true"
				[forcePanelsOpen]="true"
				[highlightQuery]="searchQuery"
				[preprocessedGroups]="details"
				(goToGroup)="selectedPartialListing.emit({ group: $event, listing })"
				(goToItem)="selectedPartialListing.emit({ item: $event.item, group: $event.group, listing })"
			></app-cart-list>
		</div>
	</div>
</ng-template>
